import React from 'react';
import { LoungeLogoV2, PriveLogoV2 } from '@lux/logo';
import { ColorMode, useColorMode } from '@lux/core';
export const Logo = ({ isPrive }) => {
    const { colorMode } = useColorMode();
    return ((!isPrive && React.createElement(LoungeLogoV2, { inverted: colorMode === ColorMode.DARK })) ||
        (isPrive && React.createElement(PriveLogoV2, { inverted: colorMode === ColorMode.DARK })));
};
//# sourceMappingURL=index.js.map